/**
 * Given the unique name of a field say dropdown containing 'Other' option,
 * this util returns the name for the input field that user interacts with
 * on selectio of 'Other' option
 * @param fieldNameWithoutSuffix The unique name id that is being used for
 * the field (The field which contains other option)
 * @returns Field name with '--other' suffix. The field name id to be used for other input field
 */
export const getOtherOptionFieldNameWithSuffix = (
    fieldNameWithoutSuffix: string
) => {
    return `${fieldNameWithoutSuffix}--other`;
};
